"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayUserCategory = void 0;
var MangopayUserCategory;
(function (MangopayUserCategory) {
    MangopayUserCategory["PAYER"] = "PAYER";
    MangopayUserCategory["OWNER"] = "OWNER";
})(MangopayUserCategory || (exports.MangopayUserCategory = MangopayUserCategory = {}));
//# sourceMappingURL=MangopayUserCategory.js.map